import { useContext } from 'react'

import trailStepContext from 'contexts/TrailStepContext'

const useTrailStep = () => {
  const context = useContext(trailStepContext)

  if (context === undefined) {
    throw new Error(
      'useTrailStep must be used within a trailStepContext.Provider',
    )
  }

  const {
    activeStep,
    activeSubStep,
    concludeStep,
    cookieBannerId,
    cookieBannerTag,
    getActivePage,
    handleBack,
    handleNext,
    hasBanner,
    helpObject,
    hideStepper,
    isCustomColorsStep,
    isDpoAppointmentStep,
    isSiteFormStep,
    jumpedToConclusion,
    jumpToConclusion,
    loadCookieBanner,
    loadCookieBannerTag,
    loaded,
    nextDisabled,
    privacyPolicy,
    privacyStamp,
    setActiveStep,
    setActiveSubStep,
    setHasBanner,
    setLoaded,
    setNextDisabled,
    setPrivacyPolicy,
    setPrivacyStamp,
    showBackButton,
    showHelpButton,
    showJumpButton,
    showNextButton,
  } = context

  const isFirstStep = activeStep === 0 && activeSubStep === 0

  const formSubmitConfigs = () => {
    const baseFormConfig = { type: 'submit' }
    if (isSiteFormStep)
      return {
        ...baseFormConfig,
        form: 'site-form',
        onClick: () => {},
      }
    if (isCustomColorsStep)
      return {
        ...baseFormConfig,
        form: 'custom-colors-form',
        onClick: () => {},
      }
    if (isDpoAppointmentStep)
      return {
        ...baseFormConfig,
        form: 'dpo-appointment-form',
        onClick: () => {},
      }

    return {}
  }

  return {
    activeStep,
    activeSubStep,
    concludeStep,
    cookieBannerId,
    cookieBannerTag,
    formSubmitConfigs,
    getActivePage,
    handleBack,
    handleNext,
    hasBanner,
    helpObject,
    hideStepper,
    isFirstStep,
    jumpedToConclusion,
    jumpToConclusion,
    loadCookieBanner,
    loadCookieBannerTag,
    loaded,
    nextDisabled,
    privacyPolicy,
    privacyStamp,
    setActiveStep,
    setActiveSubStep,
    setHasBanner,
    setLoaded,
    setNextDisabled,
    setPrivacyPolicy,
    setPrivacyStamp,
    showBackButton,
    showHelpButton,
    showJumpButton,
    showNextButton,
  }
}

export default useTrailStep
